import { Dispatch, SetStateAction, useCallback, useContext, useEffect, useState } from 'react';

import _ from 'lodash';

type Props = {
    loadingDependency: boolean;
    debounceDuration?: number;
};

type ReturnType = {
    loading: boolean;
    setLoading: Dispatch<SetStateAction<boolean>>;
};

//used to debounce Loading state, so that UI wont flicker
export const useDebounceLoading = ({ loadingDependency, debounceDuration = 300 }: Props): ReturnType => {
    const [loading, setLoading] = useState(true);

    const renderDisabledStyle = (loading: boolean) => {
        setLoading(loading);
    };
    //using a debounced function here to debounce the loading prop which changes quickly when fetching value.
    const debouncedRenderDisabledStyle = useCallback(_.debounce(renderDisabledStyle, debounceDuration), []);

    useEffect(() => {
        setLoading(true);
        debouncedRenderDisabledStyle(loadingDependency);
    }, [loadingDependency]);

    return { loading, setLoading };
};
